"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.brighten = brighten;
exports.lighten = lighten;
exports.darken = darken;
exports.opaque = opaque;
exports.default = void 0;

var _tinycolor = _interopRequireDefault(require("tinycolor2"));

function brighten(color, percent) {
  return (0, _tinycolor.default)(color).brighten(percent).toHexString();
}

function lighten(color, percent) {
  return (0, _tinycolor.default)(color).lighten(percent).toHexString();
}

function darken(color, percent) {
  return (0, _tinycolor.default)(color).darken(percent).toHexString();
}

function opaque(color, alpha) {
  return (0, _tinycolor.default)(color).setAlpha(alpha).toRgbString();
}

var _default = {
  brighten: brighten,
  darken: darken,
  lighten: lighten,
  opaque: opaque
};
exports.default = _default;